import React, { useEffect, useState } from 'react'
import qs from 'query-string'

import Components from '../../../components'
import Client from '../../../services'
import MarksheetRow from './MarksheetRow'

const marksheetTableheaderMap = {
    title: {label: "Name",},
    marks: {label: "Marks"},
    fullMarks: {label: "Full Marks"},
    timeTaken: {label: "Time Taken"},
    grade: {label: "Grade"},
    examDate: {label: "Exam Date"},
    actions: {label: "Actions"}
}

class Marksheet extends React.Component{
    state = {
        marksheetData: {},
        marksheets: {},
        courses: {},
        student: {}
    }

    componentDidMount(){
        this.loadMarksheetEntries()
    }

    loadStudentProfile = async () => {
        
    }

    loadMarksheetEntries = async () => {
        // TODO We need to take the student id from query string
        const {_student} = qs.parse(this.props.location.search)
        const {success, data, message} = await Client.api.get(`/common/exam/marksheet?_student=${_student}`)
        if(success){

            const marksheets = {}
            for(let i=0; i<data.marksheetEntries.length; i++){
                const entry = data.marksheetEntries[i];
                if(!marksheets[entry._cid]){
                    marksheets[entry._cid] = {}
                }
                marksheets[entry._cid][entry.level] = {
                    fullMarks: entry.fullMarks,
                    marks: entry.marks,
                    grade: entry.grade,
                    timeTaken: entry.timeTaken,
                    examDate: new Date(entry.examDate).toDateString(),
                    locked: entry._locked,
                    edit: false
                }
            }
            
            this.setState({
                marksheetData: marksheets,
                courses: data.courses
            }, this.prepareMarksheet)
        }else{
            Client.alert.fire({
                icon: "error",
                title: "Loading failed",
                body: message,
                confirmButton: true,
            })
        }
    }

    loadCourseDetails = async (ids) => {
        const queryString = ids.reduce((value, curr) => `${value}&_cid=${curr}`, "")

        const {success, data, message} = await Client.api.get(`/common/course/list?${queryString}`)
        if(success){
            const courses = {}
            for(let i=0; i<data.length; i++){
                courses[data[i]._id] = data[i];
            }
            console.log({courses})
            this.setState({
                courses
            }, this.prepareMarksheet)
        }
    }

    prepareMarksheet = () => {
        const marksheets = {}
        for(let index in this.state.courses){
            const { nLevel, title:name, _id:_course } = this.state.courses[index]
            const marksheetData = this.state.marksheetData[_course];
            
            const marksheet = []
            for(let i=0; i<nLevel; i++){
                let entry = marksheetData ? marksheetData[i+1] : null
                if(!entry) {
                    entry = {}
                }         
                entry = {
                    level: i+1,
                    ...entry,
                    title: `${name} ${i+1}`,
                    _course: _course
                }
                marksheet.push(entry)
            }
            marksheets[index] = marksheet;
        }
        this.setState({
            marksheets
        })
    }

    
    handleSave = async (entry) => {
        // TODO We need to take the student id from query string
        const {_student} = qs.parse(this.props.location.search)

        const payload = {
            _student,
            ...entry,
            marks: Number(entry.marks),
            fullMarks: Number(entry.fullMarks),
            timeTaken: Number(entry.timeTaken),
        }
        const {success, data, message} = await Client.api.put('/common/exam/marksheet/entry', payload)
        console.log({data})
        if(success){

            Client.alert.fire({
                icon: "success",
                title: "Marksheet Update",
                body: message,
                confirmButton: true,
            })
            return data;
        }else{
            Client.alert.fire({
                icon: "error",
                title: "Marksheet Update",
                body: message,
                confirmButton: true,
            })
            return null
        }
    }

    render(){
        return <div className="student-batch-details">
            <section>
                {
                    Object.keys(this.state.courses).map(id => {
                        if(!this.state.marksheets[id]) return null;
                        const course = this.state.courses[id];
                        return <div key={id} style={{marginTop: "10px", padding: "3px"}}>
                            <div className='u-flex' style={{marginBottom: "5px"}}>
                                Course: <u>{course.title} {`(${course.symbol})`}</u>
                            </div>
                            <table  className='u-border--px1'>
                                <thead style={{ textAlign: "center"}}>
                                    <tr>
                                        <th style={{ borderBottom: "1px solid black" }}>Subject</th>
                                        <th style={{ borderBottom: "1px solid black" }}>Full Marks</th>
                                        <th style={{ borderBottom: "1px solid black" }}>Marks</th>
                                        <th style={{ borderBottom: "1px solid black" }}>Time {"(Minute)"}</th>
                                        <th style={{ borderBottom: "1px solid black" }}>Grade</th>
                                        <th style={{ borderBottom: "1px solid black" }}>Date</th>
                                        <th style={{ borderBottom: "1px solid black" }}>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody style={{textAlign: 'center'}}>
                                    {
                                        this.state.marksheets[id].map(entry =>
                                            <MarksheetRow key={entry.level} entry={entry} onSave={this.handleSave}/>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        
                    })
                }
            </section>
        </div>
    }
}

export default Marksheet